import { render, staticRenderFns } from "./BAEventAdminRedeemPage.vue?vue&type=template&id=392b493f&"
import script from "./BAEventAdminRedeemPage.vue?vue&type=script&lang=ts&"
export * from "./BAEventAdminRedeemPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports